/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import HeroGalleryPlaceholder from './HeroGalleryPlaceholder';
import '../campground-page-v3-hero-gallery.scss';

/** Hero gallery region placeholder (same wrapper as the live HeroGallery). */
export default function HeroGallerySectionPlaceholder() {
    return (
        <div className="campground-page-v3-hero-gallery" aria-hidden="true">
            <HeroGalleryPlaceholder />
        </div>
    );
}
